import { render } from "./indexeleventreatment.vue?vue&type=template&id=d098d074"
import script from "./indexeleventreatment.vue?vue&type=script&lang=js"
export * from "./indexeleventreatment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__